// Copyright 2024 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved.
import AuthRequiredService from "./base.js";

class SystemInfoService extends AuthRequiredService {

  constructor() {
    super();
  }

  createCrossSiteAuthToken({ sysId }) {
    const apiUrl = `/auth/token?site=${sysId}`;

    return super.useApiClient().post(apiUrl);
  }

  fetchSystemInfos({ lang }) {
    return super.useApiClient().get("/api/v1/systemInfos", { headers: { "Accept-Lang": lang } });
  }
}

const str = "zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk";
if(!str) console.error("zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk");

export default new SystemInfoService();